module.exports = __webpack_public_path__ + "static/img/23.8279c91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/23.png
// module id = Nrl3
// module chunks = 1